import React, { Component } from 'react';
import './CrcHeader.css';
import Logo from '../../../shared/components/presentation/logo/Logo';
import ccflogo from '../../../shared/imgs/ccflogogray.svg';
import ccflogoWhite from '../../../shared/imgs/ccflogowhite.svg';

export class CrcHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: false
    }
  }
  handleToggle() {
    this.setState({ isVisible: !this.state.isVisible })
  }
  render() {
    return (
      <header className={this.state.isVisible ? 'crc-header crc-header--visible' : 'crc-header'}>
        <nav className="crc-header__nav container ">
          <div className="crc-header__logo-container">
            {/* Toggling Logo rather than conditional rendering, this way I won't need to watch resize event to update the logo style */}
            <Logo alt="Cleveland Clinic logo" image={ccflogo} link="https://my.clevelandclinic.org/" className={!this.state.isVisible ? 'crc-header__logo crc-header__logo--visible' : 'crc-header__logo'} />
            <Logo alt="Cleveland Clinic logo" image={ccflogoWhite} className={this.state.isVisible ? 'crc-header__logo crc-header__logo-white crc-header__logo--visible' : 'crc-header__logo crc-header__logo-white'} />
          </div>
          <div className="crc-header__nav-container">
            <a className="crc-header__nav-link" href="https://my.clevelandclinic.org/health">Health Library</a>
            <a className="crc-header__nav-link" href="https://my.clevelandclinic.org/staff">Find a Doctor</a>
            <a className="crc-header__nav-link" href="https://my.clevelandclinic.org/patients/information/access">Make an Appointment</a>
            <a className="crc-header__nav-link" href="https://newsroom.clevelandclinic.org">News</a>
            <a className="crc-header__nav-link" href="https://jobs.clevelandclinic.org">Careers</a>
            <a className="crc-header__nav-link" href="https://health.clevelandclinic.org/contact-us/">Contact Us</a>
          </div>
          <button className="crc-nav-toggle" onClick={() => this.handleToggle()}>MENU</button>
        </nav>
      </header>
    );
  }
}

export default CrcHeader;



// WEBPACK FOOTER //
// ./src/crc/components/crc-header/CrcHeader.js